import { Component, Inject, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AppComponent } from "../app/app.component";
import { forEach } from "@angular/router/src/utils/collection";
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, elementAt, window } from 'rxjs/operators';
import { ViewChild } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";

//declare var google: any;
@Component({
    selector: "councellorreview",
    template: require('./councellorreview.component.html'),
    styles: [require('./councellorreview.component.css')]
})
export class CouncellorReviewComponent implements OnChanges {
    report: CollisionReport;
    customerList: Array<String> = [];
    modelList: Array<String> = []
    colorList: Array<String> = [];
    location: GeoLocation;
    driverImages: Array<DriverPictures> = [];
    @ViewChild('gmap') gmapElement: any;
    marker1: any;
    latlong: any;
    stringformat: any;
    infowindow: any;
    street1: any;
    prep1: any; prep2: any; address: any;
    addressSplitter: any;
    map: any;
    date: Date = new Date();
    year1: any;
    year2: any;
    year3: any;
    CollisionYear: any;
    CollisionMonth: any;
    CollisionDay: any;
    statementModel: StatementData = <StatementData>{};

    FirstName: any;
    LastName: any;
    EmailAddress: any;
    PrimaryPhoneNumber: any;
    CollisionDate: any;

    constructor(private appcomponent: AppComponent, private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private router: Router, private domSanitizer: DomSanitizer) {
        this.report = appcomponent.getReport();
        if (this.report.CollisionReportUniqueId == null) {
            this.reportGetSync();
            this.router.navigate([this.router.url])
        }
        if (this.report.IsNew) {
            this.router.navigate(["home"]);
        }

        if (this.report.EntityType == "CYCLIST") {
            this.report.SequenceOfEvents1 = "4";
        }
        else if (this.report.EntityType == "PEDESTRIAN") {
            this.report.SequenceOfEvents1 = "3";

        }

        if (this.report.CollisionLocation == null) {
            this.location = <GeoLocation>{};
        }
        else {
            this.location = this.report.CollisionLocation;
        }

        this.FirstName = this.report.Firstname;
        this.LastName = this.report.Lastname;
        this.EmailAddress = this.report.EmailAddress;
        this.PrimaryPhoneNumber = this.report.PrimaryPhoneNumber;
        //this.CollisionDate = this.report.CollisionDate.toISOString().split('T')[0];
        try {
            // This does not work on page back and next. Replaced by following catch code:
            this.CollisionDate = this.report.CollisionDate.toISOString().split('T')[0];
        }
        catch (e) {
            if (this.report.CollisionDate != null) {
                var accdate = this.report.CollisionDate.toString()

                var Accyear = accdate.substring(0, 4);
                var AccMonth = accdate.substring(5, 7);
                var Accday = accdate.substring(8, 10);

                this.CollisionDate = Accyear + "-" + AccMonth + "-" + Accday;
            }
        }

        document.body.scrollTop = 0;
    }

    onPhoneInput(): void {
        var phone = this.report.PrimaryPhoneNumber.replace(/[^0-9]/g, "");
        var v = phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        this.report.PrimaryPhoneNumber = v;
    }

    onPlateInput(): void {
        var v = this.report.VehiclePlate.replace(/\s/, '').replace('_', '').replace(/\W/g, '');
        this.report.VehiclePlate = v
    }

    datePicker(): void {
        var year = this.CollisionYear

        if (year == 1) {
            year = this.date.getFullYear() 
        }
        else if (year == 2) {
            year = this.date.getFullYear() + 1
        }
        else if (year == 3) {
            year = this.date.getFullYear() + 2
        }

        var month = this.CollisionMonth
        var day = this.CollisionDay

        //alert("year: " + year + " month: " + month + " day: " + day);

        var datestring = year.toString() + '-' + month.toString() + '-' + day.toString();
        var timestring = '00:00:00';
        var insexpDate = new Date(datestring + ' ' + timestring);
        this.report.InsuranceExpiryDate = insexpDate;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (typeof changes['report'] !== "undefined") {
            // retrieve the report variable change info
            var change = changes['report'];
            // only perform the task if the value has been changed
            if (!change.isFirstChange()) {
                // execute the Http request and retrieve the result
            }
        }
        else
            console.log("Undefined");
    }

    onDidReportInsuranceChange(value: boolean): void {
        this.report.ReportToInsurance = value;
    }

    onFailToRemainChange(value: boolean): void {
        this.report.FailToRemain = value;
    }

    onBack(): void {
        this.BackAndPost("statement");
    }

    private BackAndPost(page: string): void {
        this.report.CurrentPage = page;
        this.router.navigate([page]);
    }

    onSubmit(): void {
        this.submitStatement(this.report.CollisionReportId);
        this.ValidateAndPost("finalpage");
    }

    submitStatement(reportid: number): void {
        //this.printStatement(this.report.CollisionDescription, reportid, this.report.EmailAddress);
    }

    printStatement(value: string, ReportId: any, email: string): void {
        // var url = this.baseUrl + "api/Statement/GetStatement/" + this.report.CollisionReportId + "/" + this.report.ApproximateSpeed + "/" + this.report.CollisionDescription;
        var url = this.baseUrl + "api/Statement";
        var data: StatementSuccess;

        this.statementModel.collisionReportId = this.appcomponent.getReport().CollisionReportId; //this.report.CollisionReportId 
        this.statementModel.diagram = this.report.Diagram;
        this.statementModel.signature = this.report.StatementSignature;
        this.statementModel.email = email;
        this.http
            .post(url, this.statementModel)
            .subscribe(res => {
                data = res as StatementSuccess;
                if (data.speed != 0) {
                }
                else {
                }
            }, error => console.log(error));
    }

    onDeleteInvolved(involved: InvolvedPassergerInfo): void {
        if (confirm("Do you really want to delete this entity?")) {
            for (var i = 0; i < this.report.InvolvedPassergerInfos.length; i++) {
                if (this.report.InvolvedPassergerInfos[i].InvolvedPersonIndex == involved.InvolvedPersonIndex) {

                    if (this.report.InvolvedPassergerInfos[i].InvolvedId > 0) {
                        var url = this.baseUrl + "api/report/DeleteInvolved/" + this.report.InvolvedPassergerInfos[i].InvolvedId;
                        this.http
                            .delete(url)
                            .subscribe(res => {
                                this.report.InvolvedPassergerInfos.splice(i, 1);
                            }, error => console.log(error));
                    }
                    else
                        this.report.InvolvedPassergerInfos.splice(i, 1);
                    break;
                }
            }
        }
    }

    IsValid(): boolean {
        return true;
    }

    private ValidateAndPost(page: string) {
        var isValid = this.IsValid();
        if (isValid) {
            this.report.IsCouncellorReviewPageValid = true;
            this.report.CollisionLocation = this.location;
            this.report.IsMapPageValid = true;
            this.report.IsFinalized = true;
            this.report.CurrentPage = page;
            this.appcomponent.setReport(this.report);
            this.appcomponent.CollisionReportId = this.report.CollisionReportId;
            this.router.navigate([page]);
        }
    }

    searchInsurance = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => term.length < 2 ? []
                : this.getInsuranceData(term))
        );

    getInsuranceData(term: string): Array<String> {
        var url = this.baseUrl + "api/report/Customer/" + term;
        var data: any;
        this.http
            .get(url)
            .subscribe(res => {
                data = res as string[];
                for (let i = 0; i < data.length; i++) {
                    this.customerList.push(data[i]);
                }
            }, error => console.log(error));

        if (data == null) {
            this.customerList.push("Not Found");
        }

        return Array.from(new Set(this.customerList)).filter(item =>
            item.toLowerCase().includes(term.toLowerCase()));
    }

    searchCar = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => term.length < 2 ? []
                : this.getCarData(term))
        );

    getCarData(term: string): Array<String> {
        var url = this.baseUrl + "api/report/Car/" + term;
        var data: any;
        this.http
            .get(url)
            .subscribe(res => {
                data = res as string[];
                for (let i = 0; i < data.length; i++) {
                    this.modelList.push(data[i]);
                }
            }, error => console.log(error));

        if (data == null) {
            this.modelList.push("Not Found");
        }

        return Array.from(new Set(this.modelList)).filter(item =>
            item.toLowerCase().includes(term.toLowerCase()));
    }

    searchColor = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => term.length < 2 ? []
                : this.getColorData(term))
        );

    getColorData(term: string): Array<String> {
        var url = this.baseUrl + "api/report/Color/" + term;
        var data: any;
        this.http
            .get(url)
            .subscribe(res => {
                data = res as string[];
                for (let i = 0; i < data.length; i++) {
                    this.colorList.push(data[i]);
                }
            }, error => console.log(error));

        if (data == null) {
            this.colorList.push("Not Found");
        }

        return Array.from(new Set(this.colorList)).filter(item =>
            item.toLowerCase().includes(term.toLowerCase()));
    }

    onLoadVIN(): void {
        if (this.report.VIN != null && this.report.VIN.trim().length > 0) {
            var url = this.baseUrl + "api/report/VIN/" + this.report.VIN;
            var data: any;
            this.http
                .get(url)
                .subscribe(res => {
                    data = res as VINInformation;
                    if (data) {
                        this.report.VehicleYear = data.ModelYear;
                        this.report.CarModelId = data.VehicleModelId;
                        this.report.CarMakeModel = data.CarModelName;
                    }
                }, error => console.log(error));
        }
    }

    loadimage() {
        var url = this.baseUrl + "api/driverimage/CheckImages/" + this.report.Location.LocationId + "/" + this.report.VehiclePlate;

        var data: any;

        this.http
            .get(url)
            .subscribe(res => {
                data = res as boolean;
                if (data) {
                    alert("Images Found!");
                }
                else {
                    alert("No Images Found");
                }
            }, error => console.log(error));
    }

    reportGetSync(): void {
        var url = this.baseUrl + "api/report";
        this.http
            .get(url)
            .toPromise().then(result => {
                var v = result as CollisionReport;
                this.report = v;
            });
    }
}